export default "__VITE_ASSET__CVxYFfAh__"